import { observer } from 'mobx-react';
import { orderProductModalStore } from '../../store/orderProductModalStore';
import DealComboItemsBlock from '../DealComboItemsBlock/DealComboItemsBlock';
import MealComboItemsBlock from '../MealComboItemsBlock/MealComboItemsBlock';
import ProductInfoBlock from '../ProductInfoBlock/ProductInfoBlock';
import { PRODUCT_TYPE } from 'src/types/product';

const ProductComboItemsBlock: React.FC = observer((): JSX.Element => {
  if (orderProductModalStore.product?.type === PRODUCT_TYPE.DEAL_COMBO) {
    return <DealComboItemsBlock />;
  }

  if (orderProductModalStore.product?.type === PRODUCT_TYPE.MEAL_COMBO) {
    return <MealComboItemsBlock />;
  }

  return <ProductInfoBlock />;
});

export default ProductComboItemsBlock;
